
import IndexComponent from "../../../../components/postcard_rewards/configs/Index.vue";

export default {
  components: {
    IndexComponent,
  },
};
